"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBlock = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/text");
require("@/components/common/text/semantics/heading");
require("@/components/common/text/semantics/paragraph");
const utils_1 = require("@/utils");
const textBlockLevelTokens = {
    1: { gap: 'var(--space-3)' },
    4: { gap: 'var(--space-1)' },
    5: { gap: '0' },
};
/**
 * <mm-text-block>
 * 제목과 설명 한 쌍을 세우고 그 사이 간격을 소유합니다.
 * 제목이 그 쌍을 대표하므로 heading은 필수이고, level로 문서 안의 깊이와 두 텍스트의 크기 단계를 함께 정합니다.
 * 본문을 슬롯으로 받아 구획을 이루는 자리에는 mm-content-section을 씁니다.
 */
let TextBlock = class TextBlock extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.description = '';
        this.level = '1';
        this.centered = false;
    }
    render() {
        return (0, lit_1.html) `
      <mm-heading level=${Number(this.level)}>${this.heading}</mm-heading>
      ${this.renderDescription()}
      <slot></slot>
    `;
    }
    renderDescription() {
        if (!this.description)
            return lit_1.nothing;
        if (this.level === '1') {
            return (0, lit_1.html) `
        <mm-paragraph size="large" ?centered=${this.centered}>${this.description}</mm-paragraph>
      `;
        }
        if (this.level === '5') {
            return (0, lit_1.html) `
        <mm-text size="14" color="light" ?centered=${this.centered}>${this.description}</mm-text>
      `;
        }
        return (0, lit_1.html) `
      <mm-text size="14" ?centered=${this.centered}>${this.description}</mm-text>
    `;
    }
};
TextBlock.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: var(--space-2);
    }
    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('level', textBlockLevelTokens))}
    :host([centered]) {
      align-items: center;
    }
    :host([centered]) mm-heading {
      text-align: center;
    }
    /* Level 1 전용 본문 최대 너비 제한 (가독성 최적화) */
    :host([level='1']) mm-paragraph {
      max-width: 720px;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TextBlock.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TextBlock.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], TextBlock.prototype, "level", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], TextBlock.prototype, "centered", void 0);
TextBlock = __decorate([
    (0, decorators_js_1.customElement)('mm-text-block')
], TextBlock);
exports.TextBlock = TextBlock;
//# sourceMappingURL=data:application/json;base64,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